import { gql } from '@apollo/client'

export const DELETE_UPLOAD_MUTATION = gql`
  mutation deleteUpload($id: ID!) {
    deleteUpload(id: $id)
  }
`
